export class FilSerialEntity{
    id:number;
    serial:string;
    countryId:number;
    customerId:number;
    userId:number;
    creationDate:string;

    constructor(){}
}